import React, { memo } from 'react';
import { useTranslation } from '@yme/services/i18n';
import { colorAccentSuccess700Base } from '@yme/tokens/colors';
import { HeadingLevel3, RegularTextLevel3 } from '@yme/tokens/typography';
import { formatPrice } from '@yme/utils/formatPrice';
import { getReimbursement } from '../helpers';
import { ContainerStyled, DividerStyled, RowContainerStyled } from './ReimbursementStyled';
export const Reimbursement = memo(({ items, shippingCost, parcels }) => {
    const { language, t } = useTranslation();
    const { subtotal, shipping, total } = getReimbursement(parcels, items, shippingCost);
    return (React.createElement(ContainerStyled, null,
        subtotal > 0 && (React.createElement(React.Fragment, null,
            React.createElement(RowContainerStyled, null,
                React.createElement(RegularTextLevel3, null, `${t('returnForm_selectItemsSubtotal_label')}:`),
                React.createElement(RegularTextLevel3, null, formatPrice({
                    locale: language,
                    currencyName: shippingCost.currencyCode,
                    price: subtotal,
                }))),
            React.createElement(RowContainerStyled, null,
                React.createElement(RegularTextLevel3, null, `${t('returnForm_selectItemsShippingRefund_label')}:`),
                React.createElement(RegularTextLevel3, null, formatPrice({
                    locale: language,
                    currencyName: shippingCost.currencyCode,
                    price: shipping,
                }))))),
        React.createElement(RowContainerStyled, null,
            React.createElement(RegularTextLevel3, null, `${t('returnForm_selectItemsShipping_label')}:`),
            React.createElement(RegularTextLevel3, { color: colorAccentSuccess700Base }, t('returnForm_selectItemsFreeShipping_text'))),
        subtotal > 0 && React.createElement(DividerStyled, null),
        React.createElement(RowContainerStyled, null,
            React.createElement(RegularTextLevel3, null, `${t('returnForm_selectItemsTotalReimbursement_label')}:`),
            React.createElement(HeadingLevel3, null, formatPrice({
                locale: language,
                currencyName: shippingCost.currencyCode,
                price: total,
            })))));
});
Reimbursement.displayName = 'Reimbursement';
